var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 96,
    viewBox: "0 0 142 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8345 41.958V41.958L7.8231 52.9937C-1.82952 62.6677 -1.82952 78.4968 7.81223 88.1599L7.8231 88.1708C17.4757 97.8338 33.2699 97.8338 42.9226 88.1599L67.4672 63.5719V63.6155C68.4346 62.8202 69.6738 62.3518 71.0108 62.3518C72.3587 62.3518 73.587 62.8202 74.5545 63.6155H74.5871L53.4448 42.4374C43.9117 32.8833 28.5632 32.7198 18.8345 41.958",
    fill: "#00807B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.177 52.9828L88.5769 7.28214L88.5443 7.26035C87.9464 6.65028 87.3051 6.09468 86.6637 5.56087C76.9459 -2.38092 62.4887 -1.81443 53.4557 7.24945C53.2926 7.41287 53.1404 7.56538 52.9991 7.72879L51.6295 9.10145L18.8345 41.958H18.8453C28.5741 32.7198 43.9226 32.8832 53.4557 42.4374L74.5871 63.6155L99.0774 88.1599C108.73 97.8338 124.524 97.8338 134.188 88.1599C143.829 78.4968 143.829 62.6568 134.177 52.9828",
    fill: "#00B1AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.caaf49d289276207f8ca6d673ae95147.svg";
export { ForwardRef as ReactComponent };